import React from 'react'

import './styles/SubHeader.scss';
import backgroundImg from '../../images/background.jpg'

const SubHeader = (props) => <div className="sub-title-bar" style={
  {
    'backgroundImage': `url('${backgroundImg}')`
  }
}>
  <div className="md-display-1 sub-title-bar-content" >
    <div>{ props.title }</div>
  </div>
</div>;

export default SubHeader;



// WEBPACK FOOTER //
// ./src/components/ui/SubHeader.jsx